(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5983,4291],{

/***/ 71357:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "LI": function() { return /* binding */ useIsomorphicLayoutEffect; },
/* harmony export */   "Ui": function() { return /* binding */ mediaQueryHOC; },
/* harmony export */   "ag": function() { return /* binding */ useMatchMedia; },
/* harmony export */   "hZ": function() { return /* binding */ useScrollBlock; },
/* harmony export */   "y3": function() { return /* binding */ updateCurrentProductIndex; }
/* harmony export */ });
/* harmony import */ var core_js_modules_es_object_keys_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(47941);
/* harmony import */ var core_js_modules_es_object_keys_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_keys_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_symbol_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(82526);
/* harmony import */ var core_js_modules_es_symbol_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol_js__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_array_filter_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(57327);
/* harmony import */ var core_js_modules_es_array_filter_js__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_filter_js__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptor_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(38880);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptor_js__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_get_own_property_descriptor_js__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_web_dom_collections_for_each_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(54747);
/* harmony import */ var core_js_modules_web_dom_collections_for_each_js__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_for_each_js__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptors_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(49337);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptors_js__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_get_own_property_descriptors_js__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_es_object_define_properties_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(33321);
/* harmony import */ var core_js_modules_es_object_define_properties_js__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_define_properties_js__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var core_js_modules_es_object_define_property_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(69070);
/* harmony import */ var core_js_modules_es_object_define_property_js__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_define_property_js__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _home_runner_work_mw_mt_oralb_com_cs_cz_mw_mt_oralb_com_cs_cz_node_modules_next_dist_compiled_babel_runtime_helpers_defineProperty_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(930);
/* harmony import */ var _home_runner_work_mw_mt_oralb_com_cs_cz_mw_mt_oralb_com_cs_cz_node_modules_next_dist_compiled_babel_runtime_helpers_defineProperty_js__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(_home_runner_work_mw_mt_oralb_com_cs_cz_mw_mt_oralb_com_cs_cz_node_modules_next_dist_compiled_babel_runtime_helpers_defineProperty_js__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var core_js_modules_es_array_for_each_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(89554);
/* harmony import */ var core_js_modules_es_array_for_each_js__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_for_each_js__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(41539);
/* harmony import */ var core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var core_js_modules_es_parse_int_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(91058);
/* harmony import */ var core_js_modules_es_parse_int_js__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_parse_int_js__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var core_js_modules_es_object_assign_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(19601);
/* harmony import */ var core_js_modules_es_object_assign_js__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_assign_js__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(67294);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(85893);














function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _home_runner_work_mw_mt_oralb_com_cs_cz_mw_mt_oralb_com_cs_cz_node_modules_next_dist_compiled_babel_runtime_helpers_defineProperty_js__WEBPACK_IMPORTED_MODULE_8___default()(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

 // https://github.com/streamich/react-use/blob/master/docs/useIsomorphicLayoutEffect.md


var useIsomorphicLayoutEffect =  true ? react__WEBPACK_IMPORTED_MODULE_13__.useLayoutEffect : 0;
function useMatchMedia(mediaQueryString) {
  var initialValue = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_13__.useState)(initialValue),
      match = _useState[0],
      setMatch = _useState[1];

  (0,react__WEBPACK_IMPORTED_MODULE_13__.useEffect)(function () {
    if (!window.matchMedia) {
      return;
    }

    function handleMatch(event) {
      setMatch(event.matches);
    }

    var matchMedia = window.matchMedia(mediaQueryString);
    setMatch(matchMedia.matches);
    matchMedia.addListener(handleMatch);
    return function () {
      matchMedia.removeListener(handleMatch);
    };
  }, [mediaQueryString]);
  return match;
}
var mediaQueryHOC = function mediaQueryHOC(Component) {
  function MediaQueryHOC(props) {
    var isXSmall = useMatchMedia('(max-width: 375px)');
    var isSmall = useMatchMedia('(max-width: 479px)');
    var isMedium = useMatchMedia('(max-width: 767px)');
    var isLarge = useMatchMedia('(max-width: 991px)');
    var isXLarge = useMatchMedia('(max-width: 1023px)');
    return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_14__.jsx)(Component, _objectSpread({
      isXSmall: isXSmall,
      isSmall: isSmall,
      isMedium: isMedium,
      isLarge: isLarge,
      isXLarge: isXLarge
    }, props));
  }

  return MediaQueryHOC;
};
var listeners = [];
var state = {
  currentProductIndex: 0
};

var setState = function setState(newState) {
  state = _objectSpread(_objectSpread({}, state), newState);
  listeners.forEach(function (listener) {
    listener(state);
  });
};

var updateCurrentProductIndex = function updateCurrentProductIndex() {
  var newListener = (0,react__WEBPACK_IMPORTED_MODULE_13__.useState)()[1];
  (0,react__WEBPACK_IMPORTED_MODULE_13__.useEffect)(function () {
    listeners.push(newListener);
  }, []);
  return [state, setState];
};
var useScrollBlock = function useScrollBlock() {
  var scroll = (0,react__WEBPACK_IMPORTED_MODULE_13__.useRef)(false);

  var blockScroll = function blockScroll() {
    if (typeof document === "undefined") return;
    var html = document.documentElement;
    var _document = document,
        body = _document.body;
    if (!(body == null ? void 0 : body.style) || scroll.current) return;
    var scrollBarWidth = window.innerWidth - html.clientWidth;
    var bodyPaddingRight = parseInt(window.getComputedStyle(body).getPropertyValue("padding-right")) || 0;
    Object.assign(html.style, {
      position: "relative",
      overflow: "hidden"
    });
    Object.assign(body.style, {
      position: "relative",
      overflow: "hidden",
      paddingRight: "".concat(bodyPaddingRight + scrollBarWidth, "px")
    });
    scroll.current = true;
  };

  var allowScroll = function allowScroll() {
    if (typeof document === "undefined") return;
    var html = document.documentElement;
    var _document2 = document,
        body = _document2.body;
    if (!(body == null ? void 0 : body.style) || !scroll.current) return;
    Object.assign(html.style, {
      position: "",
      overflow: ""
    });
    Object.assign(body.style, {
      position: "",
      overflow: "",
      paddingRight: ""
    });
    scroll.current = false;
  };

  return [blockScroll, allowScroll];
};

/***/ }),

/***/ 44291:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Label": function() { return /* binding */ Label; },
/* harmony export */   "LabelHTML": function() { return /* binding */ LabelHTML; },
/* harmony export */   "replaceTokensFromString": function() { return /* binding */ replaceTokensFromString; }
/* harmony export */ });
/* harmony import */ var core_js_modules_es_object_keys_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(47941);
/* harmony import */ var core_js_modules_es_object_keys_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_keys_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_symbol_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(82526);
/* harmony import */ var core_js_modules_es_symbol_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol_js__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_array_filter_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(57327);
/* harmony import */ var core_js_modules_es_array_filter_js__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_filter_js__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(41539);
/* harmony import */ var core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptor_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(38880);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptor_js__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_get_own_property_descriptor_js__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_array_for_each_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(89554);
/* harmony import */ var core_js_modules_es_array_for_each_js__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_for_each_js__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_web_dom_collections_for_each_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(54747);
/* harmony import */ var core_js_modules_web_dom_collections_for_each_js__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_for_each_js__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptors_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(49337);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptors_js__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_get_own_property_descriptors_js__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var core_js_modules_es_object_define_properties_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(33321);
/* harmony import */ var core_js_modules_es_object_define_properties_js__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_define_properties_js__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var core_js_modules_es_object_define_property_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(69070);
/* harmony import */ var core_js_modules_es_object_define_property_js__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_define_property_js__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var _home_runner_work_mw_mt_oralb_com_cs_cz_mw_mt_oralb_com_cs_cz_node_modules_next_dist_compiled_babel_runtime_helpers_defineProperty_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(930);
/* harmony import */ var _home_runner_work_mw_mt_oralb_com_cs_cz_mw_mt_oralb_com_cs_cz_node_modules_next_dist_compiled_babel_runtime_helpers_defineProperty_js__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(_home_runner_work_mw_mt_oralb_com_cs_cz_mw_mt_oralb_com_cs_cz_node_modules_next_dist_compiled_babel_runtime_helpers_defineProperty_js__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var _home_runner_work_mw_mt_oralb_com_cs_cz_mw_mt_oralb_com_cs_cz_node_modules_next_dist_compiled_babel_runtime_helpers_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(3323);
/* harmony import */ var _home_runner_work_mw_mt_oralb_com_cs_cz_mw_mt_oralb_com_cs_cz_node_modules_next_dist_compiled_babel_runtime_helpers_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(_home_runner_work_mw_mt_oralb_com_cs_cz_mw_mt_oralb_com_cs_cz_node_modules_next_dist_compiled_babel_runtime_helpers_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var core_js_modules_es_regexp_exec_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(74916);
/* harmony import */ var core_js_modules_es_regexp_exec_js__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_exec_js__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var core_js_modules_es_string_replace_js__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(15306);
/* harmony import */ var core_js_modules_es_string_replace_js__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_replace_js__WEBPACK_IMPORTED_MODULE_13__);
/* harmony import */ var core_js_modules_es_regexp_constructor_js__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(24603);
/* harmony import */ var core_js_modules_es_regexp_constructor_js__WEBPACK_IMPORTED_MODULE_14___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_constructor_js__WEBPACK_IMPORTED_MODULE_14__);
/* harmony import */ var core_js_modules_es_regexp_sticky_js__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(88386);
/* harmony import */ var core_js_modules_es_regexp_sticky_js__WEBPACK_IMPORTED_MODULE_15___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_sticky_js__WEBPACK_IMPORTED_MODULE_15__);
/* harmony import */ var core_js_modules_es_regexp_to_string_js__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(39714);
/* harmony import */ var core_js_modules_es_regexp_to_string_js__WEBPACK_IMPORTED_MODULE_16___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string_js__WEBPACK_IMPORTED_MODULE_16__);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_17___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_17__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(67294);
/* harmony import */ var isomorphic_dompurify__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(29238);
/* harmony import */ var isomorphic_dompurify__WEBPACK_IMPORTED_MODULE_19___default = /*#__PURE__*/__webpack_require__.n(isomorphic_dompurify__WEBPACK_IMPORTED_MODULE_19__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(85893);












var _excluded = ["label", "tokens"];






function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _home_runner_work_mw_mt_oralb_com_cs_cz_mw_mt_oralb_com_cs_cz_node_modules_next_dist_compiled_babel_runtime_helpers_defineProperty_js__WEBPACK_IMPORTED_MODULE_10___default()(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }





/* harmony default export */ __webpack_exports__["default"] = (Label);
function Label(_ref) {
  var label = _ref.label,
      tokens = _ref.tokens;

  if (!label) {
    return '';
  } else if (tokens) {
    var _label$fields;

    return replaceTokensFromString((label == null ? void 0 : (_label$fields = label.fields) == null ? void 0 : _label$fields.text) || label, tokens);
  } else {
    var _label$fields2;

    return (label == null ? void 0 : (_label$fields2 = label.fields) == null ? void 0 : _label$fields2.text) || label;
  }
}
Label.propTypes = {
  label: prop_types__WEBPACK_IMPORTED_MODULE_17___default().oneOfType([(prop_types__WEBPACK_IMPORTED_MODULE_17___default().string), (prop_types__WEBPACK_IMPORTED_MODULE_17___default().object)]),
  tokens: (prop_types__WEBPACK_IMPORTED_MODULE_17___default().object)
};
function LabelHTML(_ref2) {
  var label = _ref2.label,
      tokens = _ref2.tokens,
      props = _home_runner_work_mw_mt_oralb_com_cs_cz_mw_mt_oralb_com_cs_cz_node_modules_next_dist_compiled_babel_runtime_helpers_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_11___default()(_ref2, _excluded);

  if (!label) {
    return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_20__.jsx)("span", _objectSpread({}, props));
  } else if (tokens) {
    var _label$fields3;

    return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_20__.jsx)("span", _objectSpread({
      dangerouslySetInnerHTML: {
        __html: isomorphic_dompurify__WEBPACK_IMPORTED_MODULE_19___default().sanitize(replaceTokensFromString((label == null ? void 0 : (_label$fields3 = label.fields) == null ? void 0 : _label$fields3.text) || label, tokens))
      }
    }, props));
  } else {
    var _label$fields4;

    return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_20__.jsx)("span", _objectSpread({
      dangerouslySetInnerHTML: {
        __html: isomorphic_dompurify__WEBPACK_IMPORTED_MODULE_19___default().sanitize((label == null ? void 0 : (_label$fields4 = label.fields) == null ? void 0 : _label$fields4.text) || label)
      }
    }, props));
  }
}
function replaceTokensFromString(s, tokens) {
  for (var tokenKey in tokens) {
    s = s.replace(new RegExp('{' + tokenKey + '}', 'g'), tokens[tokenKey]);
  }

  return s;
}

/***/ }),

/***/ 75983:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(41539);
/* harmony import */ var core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_promise_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(88674);
/* harmony import */ var core_js_modules_es_promise_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_promise_js__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_symbol_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(82526);
/* harmony import */ var core_js_modules_es_symbol_js__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol_js__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_symbol_description_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(41817);
/* harmony import */ var core_js_modules_es_symbol_description_js__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol_description_js__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_array_concat_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(92222);
/* harmony import */ var core_js_modules_es_array_concat_js__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_concat_js__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(67294);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(5152);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(next_dynamic__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _adapters_helpers_Constants__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(24036);
/* harmony import */ var _adapters_helpers_Block__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(40483);
/* harmony import */ var _adapters_helpers_Hooks__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(71357);
/* harmony import */ var _Label_Label__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(44291);
/* harmony import */ var _adapters_helpers_Loader__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(47322);
/* harmony import */ var isomorphic_dompurify__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(29238);
/* harmony import */ var isomorphic_dompurify__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(isomorphic_dompurify__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(85893);












var Heading = next_dynamic__WEBPACK_IMPORTED_MODULE_6___default()(function () {
  return __webpack_require__.e(/* import() */ 2116).then(__webpack_require__.bind(__webpack_require__, 92116));
}, {
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(92116)];
    }
  }
});
var ObLink = next_dynamic__WEBPACK_IMPORTED_MODULE_6___default()(function () {
  return Promise.all(/* import() */[__webpack_require__.e(1664), __webpack_require__.e(8958)]).then(__webpack_require__.bind(__webpack_require__, 61769));
}, {
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(61769)];
    }
  }
});
var Image = next_dynamic__WEBPACK_IMPORTED_MODULE_6___default()(function () {
  return __webpack_require__.e(/* import() */ 8084).then(__webpack_require__.bind(__webpack_require__, 48084));
}, {
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(48084)];
    }
  }
});
var Disclaimer = next_dynamic__WEBPACK_IMPORTED_MODULE_6___default()(function () {
  return Promise.all(/* import() */[__webpack_require__.e(4885), __webpack_require__.e(1036), __webpack_require__.e(8996), __webpack_require__.e(4588)]).then(__webpack_require__.bind(__webpack_require__, 77770));
}, {
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(77770)];
    }
  }
});




function LegacyArticleHeroBlock(props) {
  var _extraAttributes$enti, _extraAttributes$enti2, _extraAttributes$enti3, _extraAttributes$enti4, _extraAttributes$enti5, _extraAttributes$enti6, _extraAttributes$enti7, _extraAttributes$enti8, _extraAttributes$enti9, _extraAttributes$enti10, _extraAttributes$enti11, _extraAttributes$enti12, _extraAttributes$enti13, _extraAttributes$enti14, _extraAttributes$enti15, _extraAttributes$enti16, _extraAttributes$enti17, _extraAttributes$enti18, _extraAttributes$enti19, _extraAttributes$enti20, _extraAttributes$enti21, _extraAttributes$enti22, _extraAttributes$enti23, _extraAttributes$enti24, _block$fields;

  var block = new _adapters_helpers_Block__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z(props);
  var extraAttributes = props.extraAttributes,
      isMedium = props.isMedium;
  var className = block.getFieldValue('classNames');
  var anchorId = block.getAnchorId();
  var showImage = extraAttributes == null ? void 0 : (_extraAttributes$enti = extraAttributes.entity) == null ? void 0 : (_extraAttributes$enti2 = _extraAttributes$enti.articleOverview) == null ? void 0 : (_extraAttributes$enti3 = _extraAttributes$enti2.fields) == null ? void 0 : _extraAttributes$enti3.showImage;
  var thumbnailImage = extraAttributes == null ? void 0 : (_extraAttributes$enti4 = extraAttributes.entity) == null ? void 0 : (_extraAttributes$enti5 = _extraAttributes$enti4.articleOverview) == null ? void 0 : (_extraAttributes$enti6 = _extraAttributes$enti5.fields) == null ? void 0 : _extraAttributes$enti6.thumbnailImage;
  var mobileImage = extraAttributes == null ? void 0 : (_extraAttributes$enti7 = extraAttributes.entity) == null ? void 0 : (_extraAttributes$enti8 = _extraAttributes$enti7.articleOverview) == null ? void 0 : (_extraAttributes$enti9 = _extraAttributes$enti8.fields) == null ? void 0 : _extraAttributes$enti9.mobileThumbnail;
  var title = extraAttributes == null ? void 0 : (_extraAttributes$enti10 = extraAttributes.entity) == null ? void 0 : (_extraAttributes$enti11 = _extraAttributes$enti10.articleOverview) == null ? void 0 : (_extraAttributes$enti12 = _extraAttributes$enti11.fields) == null ? void 0 : _extraAttributes$enti12.title;
  var eyebrow = extraAttributes == null ? void 0 : (_extraAttributes$enti13 = extraAttributes.entity) == null ? void 0 : (_extraAttributes$enti14 = _extraAttributes$enti13.category) == null ? void 0 : (_extraAttributes$enti15 = _extraAttributes$enti14.fields) == null ? void 0 : _extraAttributes$enti15.title;
  var slug = extraAttributes == null ? void 0 : (_extraAttributes$enti16 = extraAttributes.entity) == null ? void 0 : (_extraAttributes$enti17 = _extraAttributes$enti16.category) == null ? void 0 : (_extraAttributes$enti18 = _extraAttributes$enti17.fields) == null ? void 0 : (_extraAttributes$enti19 = _extraAttributes$enti18.slug) == null ? void 0 : (_extraAttributes$enti20 = _extraAttributes$enti19.fields) == null ? void 0 : _extraAttributes$enti20.slug;
  var readingTimeLabel = (0,_Label_Label__WEBPACK_IMPORTED_MODULE_10__.Label)({
    label: block.getFieldValue(_adapters_helpers_Constants__WEBPACK_IMPORTED_MODULE_7__/* .ArticleHeroBlockConstants.readTimeLabel */ .D4.readTimeLabel),
    tokens: {
      readTime: extraAttributes.entity.articleOverview.fields.readTime
    }
  });
  var body = extraAttributes == null ? void 0 : (_extraAttributes$enti21 = extraAttributes.entity) == null ? void 0 : (_extraAttributes$enti22 = _extraAttributes$enti21.articleOverview) == null ? void 0 : (_extraAttributes$enti23 = _extraAttributes$enti22.fields) == null ? void 0 : _extraAttributes$enti23.description;
  var backgroundAsset = extraAttributes == null ? void 0 : (_extraAttributes$enti24 = extraAttributes.entity) == null ? void 0 : _extraAttributes$enti24.backgroundAsset;
  var disclaimer = block == null ? void 0 : (_block$fields = block.fields) == null ? void 0 : _block$fields.disclaimer;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__.jsx)(react__WEBPACK_IMPORTED_MODULE_5__.Suspense, {
    fallback: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__.jsx)(_adapters_helpers_Loader__WEBPACK_IMPORTED_MODULE_11__["default"], {}),
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__.jsx)("div", {
      className: "ob-legacy-article-hero ".concat(className || '', " ").concat(showImage ? 'ob-legacy-no-padding' : ''),
      id: anchorId,
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__.jsxs)("div", {
        className: "ob-legacy-article-hero__inner",
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__.jsx)(ObLink, {
          href: "".concat(slug),
          children: eyebrow
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__.jsx)(react__WEBPACK_IMPORTED_MODULE_5__.Suspense, {
          fallback: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__.jsx)(_adapters_helpers_Loader__WEBPACK_IMPORTED_MODULE_11__["default"], {}),
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__.jsx)(Heading, {
            className: "ob-legacy-article-hero__heading",
            tag: "h1",
            children: title
          })
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__.jsx)(react__WEBPACK_IMPORTED_MODULE_5__.Suspense, {
          fallback: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__.jsx)(_adapters_helpers_Loader__WEBPACK_IMPORTED_MODULE_11__["default"], {}),
          children: showImage && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__.jsx)("div", {
            children: isMedium ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__.jsx)(Image, {
              image: mobileImage
            }) : /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__.jsx)(Image, {
              image: thumbnailImage
            })
          })
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__.jsx)("div", {
          className: "ob-legacy-article-hero__text",
          dangerouslySetInnerHTML: {
            __html: isomorphic_dompurify__WEBPACK_IMPORTED_MODULE_12___default().sanitize(body)
          }
        }), readingTimeLabel && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__.jsx)("p", {
          className: "ob-legacy-article-hero__time",
          children: readingTimeLabel
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__.jsx)(react__WEBPACK_IMPORTED_MODULE_5__.Suspense, {
          fallback: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__.jsx)(_adapters_helpers_Loader__WEBPACK_IMPORTED_MODULE_11__["default"], {}),
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__.jsx)(Image, {
            image: backgroundAsset,
            text: _adapters_helpers_Constants__WEBPACK_IMPORTED_MODULE_7__/* .ArticleHeroBlockConstants.articleBanner */ .D4.articleBanner
          })
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__.jsx)(react__WEBPACK_IMPORTED_MODULE_5__.Suspense, {
          fallback: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__.jsx)(_adapters_helpers_Loader__WEBPACK_IMPORTED_MODULE_11__["default"], {}),
          children: disclaimer && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__.jsx)(Disclaimer, {
            document: disclaimer
          })
        })]
      })
    })
  });
}

/* harmony default export */ __webpack_exports__["default"] = ((0,_adapters_helpers_Hooks__WEBPACK_IMPORTED_MODULE_9__/* .mediaQueryHOC */ .Ui)(LegacyArticleHeroBlock));

/***/ }),

/***/ 3323:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var objectWithoutPropertiesLoose = __webpack_require__(57826);

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = objectWithoutPropertiesLoose(source, excluded);
  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

module.exports = _objectWithoutProperties;
module.exports["default"] = module.exports, module.exports.__esModule = true;

/***/ }),

/***/ 57826:
/***/ (function(module) {

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

module.exports = _objectWithoutPropertiesLoose;
module.exports["default"] = module.exports, module.exports.__esModule = true;

/***/ })

}]);